import { call, put, takeLatest } from 'redux-saga/effects';
import participationActions from '../actions/ParticipationActions';
import ParticipationApi from '../apis/ParticipationApi';

function* get(action) {
    try {
        const id = action.payload;
        const res = yield call(ParticipationApi.get, {id});
        yield put(participationActions.getFormSuccess(res));
    } catch (err) {
        yield put(participationActions.getFormFailed(err));
    }
}

function* save(action) {
    try {
        const {playerInfo, eventInfo, history} = action.payload;
        const res = yield call(ParticipationApi.save, {playerInfo, eventInfo});
        yield put(participationActions.saveFormSuccess(res));
        history.push('/competitive/success');
    } catch (err) {
        yield put(participationActions.saveFormFailed(err));
    }
}

function* ParticipationSaga() {
    yield takeLatest(participationActions.TYPES.GET_PARTICIPATION_FORM, get);
    yield takeLatest(participationActions.TYPES.SAVE_PARTICIPATION_FORM, save);
}

export default ParticipationSaga;
